import { useBrowserTitle } from './useBrowserTitle';
import { useTrackPage } from './useTrackPage';

export function RouterSideEffects() {
  useBrowserTitle();
  useTrackPage();

  return null;
}
